import { render, staticRenderFns } from "./AddUserPage.vue?vue&type=template&id=458f016a&"
import script from "./AddUserPage.vue?vue&type=script&lang=js&"
export * from "./AddUserPage.vue?vue&type=script&lang=js&"
import style0 from "./AddUserPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports